import { Funcionario } from './funcionario.dto';

export class Membro extends Funcionario{

}
